<template>
  <div>
    <v-card class="mx-auto my-4 mb-8" max-width="800" flat outlined>
      <v-card-title>{{ $t("settings.incidentReport.title") }}</v-card-title>
      <v-card-text>
        <div class="subtitle-1 mb-3">{{ $t("incidentReports.steps.companyData") }}</div>
        <v-row dense>
          <v-col cols="12">
            <v-text-field v-model="form.name" :label="$t('incidentReports.fields.companyName')" outlined dense />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field v-model="form.street" :label="$t('incidentReports.fields.street')" outlined dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="form.houseNumber" :label="$t('incidentReports.fields.houseNumber')" outlined dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="form.zip" :label="$t('incidentReports.fields.zip')" outlined dense />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field v-model="form.city" :label="$t('incidentReports.fields.city')" outlined dense />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.companyNumber"
              :label="$t('incidentReports.fields.insurerCompanyNumber')"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <div class="subtitle-1 mt-2 mb-3">{{ $t("settings.incidentReport.recipient") }}</div>
        <v-row dense>
          <v-col cols="12">
            <v-text-field v-model="form.recipientName" :label="$t('incidentReports.fields.recipientName')" outlined dense />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field v-model="form.recipientStreet" :label="$t('incidentReports.fields.recipientStreet')" outlined dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="form.recipientHouseNumber"
              :label="$t('incidentReports.fields.recipientHouseNumber')"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="form.recipientZip" :label="$t('incidentReports.fields.recipientZip')" outlined dense />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field v-model="form.recipientCity" :label="$t('incidentReports.fields.recipientCity')" outlined dense />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn color="primary" depressed :loading="saving" @click="save">
          {{ $t("general.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
const FIELDS = [
  "name",
  "street",
  "houseNumber",
  "zip",
  "city",
  "companyNumber",
  "recipientName",
  "recipientStreet",
  "recipientHouseNumber",
  "recipientZip",
  "recipientCity",
];

function emptyForm() {
  return Object.fromEntries(FIELDS.map((key) => [key, ""]));
}

export default {
  name: "incidentReportSettings",
  data: () => ({
    form: emptyForm(),
    saving: false,
  }),
  async created() {
    const setting = await this.$store.dispatch("getSettingData", "incidentReportCompanyData");
    this.form = { ...emptyForm(), ...((setting && setting.value) || {}) };
  },
  methods: {
    async save() {
      this.saving = true;
      try {
        const value = Object.fromEntries(
          FIELDS.map((key) => [key, String(this.form[key] || "").trim()])
        );
        await this.$store.dispatch("setSettingData", {
          id: "incidentReportCompanyData",
          value,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
